import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { PortfolioStoreModule } from './module';

export const PortfolioModule = getModule(PortfolioStoreModule, store);
